import { BrowserRouter, Route, Routes } from 'react-router-dom'
import AppShell from './components/layout/AppShell'
import Builder from './pages/Builder'
import Home from './pages/Home'
import Job from './pages/Job'
import LocalUpload from './pages/LocalUpload'
import NotFound from './pages/NotFound'

function App() {
  return (
    <BrowserRouter>
      <AppShell>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/builder" element={<Builder />} />
          <Route path="/local" element={<LocalUpload />} />
          <Route path="/job/:id" element={<Job />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AppShell>
    </BrowserRouter>
  )
}

export default App
